module.exports = __webpack_public_path__ + "img/57.128d1bd6.jpg";